export class AlertTemplateAppModel {
	public message?: string;
	public cancelButtonLabel: string;
	public saveButtonLabel: string;
	public input?: string;
	public inputName?: string;
}
